"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./DataPoint.scss");
var _checkForThemeProps = require("../../utils/checkForThemeProps");
var _DataPointMethods = require("./DataPointMethods");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const DataPoint = _ref => {
  let {
    contentfulId,
    points,
    theme,
    variant,
    paddingClass
  } = _ref;
  const themes = (0, _checkForThemeProps.checkForThemeProps)(theme);
  const updatedVariant = (0, _DataPointMethods.formatPoints)(points, variant) && (0, _DataPointMethods.formatPoints)(points, variant)?.variant ? (0, _DataPointMethods.formatPoints)(points, variant).variant : "variant_1";
  const sbProps = contentfulId ? {
    "data-sb-object-id": contentfulId
  } : null;
  return /*#__PURE__*/_react.default.createElement("div", _extends({}, sbProps, {
    className: `data-point data-point--${updatedVariant} ${paddingClass}`,
    style: {
      backgroundColor: themes?.backgroundColor || "#ffffff"
    }
  }), (0, _DataPointMethods.formatPoints)(points, variant)?.points && (0, _DataPointMethods.formatPoints)(points, variant).points.map((point, i) => {
    return /*#__PURE__*/_react.default.createElement(_DataPointMethods.Point, {
      contentfulId: point.contentfulId,
      key: i,
      index: i,
      header: point?.header,
      description: point?.description,
      icon: point?.icon,
      variant: updatedVariant,
      themes: themes
    });
  }));
};
var _default = DataPoint;
exports.default = _default;